<template>
  <div class="" v-if="ready">
    <span v-if="loading" class="loading">
      <ClipLoader color="#2e3f50" :loading="loading" :size="20" />
    </span>
    <div v-if="requestHistoryModel && requestHistoryModel.length" class="StudentGroups__Container">
      <div class="StudentGroupsWidget__Component"
        v-for="history in requestHistoryModel" :key="history.id">
        <p>בתאריך {{ history.date }} {{ history.from }}: {{ history.name }}</p>
      </div>
    </div>
    <div v-if="!loading && !requestHistoryModel.length">אין היסטוריה למשתמש</div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { ClipLoader } from "@saeris/vue-spinners";
import moment from "moment";
import { ModalProgrammatic as Modal } from "buefy";
import UserService from "../../services/UserService";

export default {
  name: "ClientWidget",
  props: ["ready", "namespace", "fetch"],
  components: {
    ClipLoader,
  },
  data() {
    return {
      requestHistoryModel: null,
      loading: false
    };
  },
  beforeCreate() {
    const { namespace } = this.$options.propsData;
    const { mapState } = createNamespacedHelpers(namespace);
    this.$options.computed = {
      ...mapState(["id", "privateName", "lastName"]),
    };
  },
  created() {
    // if (this.id) {
    //   UserService.getUsertracks(this.id)
    //     .then((res) => {
    //       this.requestHistoryModel = res.data;
    //     });
    // }
  },
  computed: {
  },
  methods: {
    displayDate() {
      return moment(this.CreateDate).format("DD/MM/YYYY");
    },
    init() {
      if (this.id) {
        this.loading = true;
        UserService.getUserTracks(this.id)
          .then((res) => {
            this.requestHistoryModel = res.data.filter((t) => t.isSelected);
          }).finally(() => {
            this.$emit('onReady', { titleCount: this.requestHistoryModel?.length });
            this.loading = false;
          });
        this.$emit("onReady", true);
      }
    },
  },
  watch: {
    ready(newValue) {
      if (newValue) {
        this.init();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.StudentGroups__Container {
  max-height: 400px;
  padding: 0 10px;
  overflow: auto;
}

.edit-section {
  padding: 0 0 10px 10px;
  display: flex;
  flex-direction: row-reverse;
  a:hover {
    text-decoration: underline;
  }
}

.StudentGroupsWidget__Component {
  width: 100%;
  border-radius: 3px;
  margin-top: 5px;
  padding: 10px;
  border: 1px solid #e4eaf1;
  background-color: #eef1f3;
  border-radius: 3px;
  position: relative;
}

.green {
  background-color: #dff0d8;
}

.preview {
  position: absolute;
  left: 10px;
  top: 10px;
  color: #57b7ca;
  cursor: pointer;
  font-weight: 500 !important;

  &:hover {
    text-decoration: underline;
  }
}
</style>
